import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { debounceTime, Observable, Subject, takeUntil } from 'rxjs';
import { BOM_FixedCutterInput, FixedCutterPreBOMInput } from '../../interfaces/request';
import { RequestActions } from '../../store/action/request.action';

@Component({
    selector: 'app-router-data',
    templateUrl: './router-data.component.html',
    styleUrl: './router-data.component.css',
    standalone: false
})
export class RouterDataComponent {

  @Input() sapInitial$?: Observable<FixedCutterPreBOMInput>;
  @Input() draftId?: number;

  public appRouterData!: FormGroup;
  private latestSapInput!: FixedCutterPreBOMInput;
  public sleeveRouters: string[] = [];
  public bitHeadRouters: string[] = [];
  public Steeltypeoptions: string[] = [];
  public ManualRouter: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private store: Store, private fb: FormBuilder) {
    this.appRouterData = this.fb.group({
      PreMachine: [null],
      UniversalBlank: [null],
      ABCoating: [null],
      Casting: [null],
      TwoPieceToOnePiece: [null],
      SteelType: [null]
    });
  }

  ngOnInit(): void {
    this.getRouters();
    this.sapInitial$!
      .pipe(takeUntil(this.destroy$))
      .subscribe(sap => {
        this.latestSapInput = sap;
        const inpu = sap.FixedCutterInput as BOM_FixedCutterInput;
        this.appRouterData.patchValue({
          PreMachine: inpu.preMachine,
          UniversalBlank: inpu.universalBlank,
          //ABCoating: inpu.aBCoating,
          //Casting: inpu.Casting,
          //TwoPieceToOnePiece: inpu.TwoPieceToOnePiece,
          //SteelType: inpu.SteelType
        }, { emitEvent: false });
      });
    this.appRouterData.valueChanges
      .pipe(
        debounceTime(200),
        takeUntil(this.destroy$)
      )
      .subscribe(changes => {
        const updated: FixedCutterPreBOMInput = {
          ...this.latestSapInput,
          FixedCutterInput: {
            ...this.latestSapInput.FixedCutterInput,
            ...changes
          }
        };
        this.store.dispatch(new RequestActions.PatchRequestDraft({
          draftId: this.draftId,
          changes: { fixedCutterSapData: updated }
        }));
      });;
  }
  public getRouters() {
    // var routerParamters = {
    //   "BrazedPorts": this.Request.fixedCutterSapData.FixedCutterInput?.FixedCutterBrazedIns.length === 0 ? false : true,
    //   "UniversalBlank": this.Request.fixedCutterSapData.FixedCutterInput?.UniversalBlank ?? false,
    //   "ABCoating": this.Request.fixedCutterSapData.FixedCutterInput?.ABCoating ?? false,
    //   "UpperSection": this.Request.fixedCutterSapData.FixedCutterInput?.UpperSection ?? '',
    //   "Casting": this.Request.fixedCutterSapData.FixedCutterInput?.Casting ?? false,
    //   "PreMachine": this.Request.fixedCutterSapData.FixedCutterInput?.PreMachine ?? false,
    //   "TwoPieceToOnePiece": this.Request.fixedCutterSapData.FixedCutterInput?.TwoPieceToOnePiece ?? false,
    //   "SleeveType": this.Request.fixedCutterSapData.FixedCutterInput?.FixedCutterSleeves.length === 0 || this.Request.fixedCutterSapData.FixedCutterInput.FixedCutterSleeves[0]?.SleeveType === undefined ? "None" : this.Request.fixedCutterSapData.FixedCutterInput.FixedCutterSleeves[0].SleeveType,
    //   "SteelType": this.Request.fixedCutterSapData.FixedCutterInput?.SteelType ?? '',
    //   "CuttersOnSleeve": this.Request.fixedCutterSapData.FixedCutterInput?.FixedCutterSleeves.length === 0 || this.Request.fixedCutterSapData.FixedCutterInput.FixedCutterSleeves[0]?.CuttersOnSleeve ? false : this.Request.fixedCutterSapData.FixedCutterInput.FixedCutterSleeves[0].CuttersOnSleeve,
    // }
    // this.service.getRouters(this.Request.order.Id, routerParamters).subscribe((x) => {
    //   this.bitHeadRouters = x['data'].filter((res) => res.Type === 'BitHead').map((router) => router.Name);
    //   this.sleeveRouters = x['data'].filter((res) => res.Type === 'Sleeve').map((router) => router.Name);
    // });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
